import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as cronJobsApi from "@api/cron-jobs.api";
import type { CronJob } from "@/types";

interface CronJobsState {
  list: CronJob[];
  loading: boolean;
}

const initialState: CronJobsState = {
  list: [],
  loading: false,
};

export const fetchCronJobs = createAsyncThunk(
  "cronJobs/fetchAll",
  async (scraperId?: string) => {
    return await cronJobsApi.getAll(scraperId);
  },
);

export const createCronJob = createAsyncThunk(
  "cronJobs/create",
  async (data: { scraperId: string; name: string; expression: string }) => {
    return await cronJobsApi.create(data);
  },
);

export const deleteCronJob = createAsyncThunk(
  "cronJobs/delete",
  async (id: string) => {
    await cronJobsApi.remove(id);
    return id;
  },
);

export const startCronJob = createAsyncThunk(
  "cronJobs/start",
  async (id: string) => {
    return await cronJobsApi.start(id);
  },
);

export const stopCronJob = createAsyncThunk(
  "cronJobs/stop",
  async (id: string) => {
    return await cronJobsApi.stop(id);
  },
);

const cronJobsSlice = createSlice({
  name: "cronJobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCronJobs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCronJobs.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchCronJobs.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createCronJob.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(deleteCronJob.fulfilled, (state, action) => {
        state.list = state.list.filter((j) => j.id !== action.payload);
      })
      .addCase(startCronJob.fulfilled, (state, action) => {
        const idx = state.list.findIndex((j) => j.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(stopCronJob.fulfilled, (state, action) => {
        const idx = state.list.findIndex((j) => j.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      });
  },
});

export default cronJobsSlice.reducer;
